import { connect } from 'react-redux'
import DestinationsField from '../components/destinations_field'

const mapStateToProps = ({ form }) => ({
  paramKey: form.paramKey
})

const connected = connect(mapStateToProps)(DestinationsField)

export default connected
